import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
  dsn: 'https://6fb072d5d38f3a901d47bcc5bcb5d544@o4511756337086464.ingest.de.sentry.io/4511756338266192',
  dataCollection: {},
});
Sentry.setTag('application', 'trader');

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((err: unknown) => {
  console.error(err);
});
